import {Injectable, OnDestroy} from '@angular/core';
import {Headers, Http, Response} from '@angular/http';
import {environment} from '../../environments/environment';
import {Cookie} from 'ng2-cookies/ng2-cookies';
import {LocalStorageService} from 'angular-2-local-storage';
import {Observable} from 'rxjs/Observable';
import {User} from './model/user';
import {Subscription} from 'rxjs/Subscription';
import {EventService} from './event.service';
import {Jsonp} from '@angular/http';

import { TranslateService } from '@ngx-translate/core';

import {ModalService} from "../services/modalService/modal.service";
import {GenericModalComponent} from "../generic-modal/generic-modal.component";

@Injectable()
export class LoginService implements OnDestroy {
  private currentUser: User = this.getAnonymousUser();
  private subscription: Subscription;

  constructor(private http: Http,
  			  private jsonp: Jsonp,
              private localStorageService: LocalStorageService,
              private eventService: EventService,
              private modalService: ModalService,
              private translate: TranslateService) {
    this.subscription = this.eventService.getMessage().subscribe(message => {
        if (message.type === 'updateUser') {
        	let authUrl = `?currentUserLanguage=${window.localStorage.getItem('lang')}`;
            this.authenticate(authUrl).subscribe((user) => {
            });
        }
    });
  }

  public resendEmailValidation(): any {
    return this.http.get(`${environment.baseURL}/${environment.auth}/emailvalidation/resend?currentUserLanguage=${window.localStorage.getItem('lang')}`);
  }
  
  public serverLocalization(): void {
    this.http.get(`${environment.baseURL}/api/localization/user?currentUserLanguage=${window.localStorage.getItem('lang')}`).subscribe();
  }

  public signOut(notification = null) {
    this.cleanupLocalStorage();

    return this.http.post(`${environment.baseURL}/api/logout`, '')
      .subscribe((res: Response) => {
        const headers = res.headers;
        this.trackCookie(headers.get('jsessionid'));
        this.localStorageService.remove('ruid');
        this.currentUser = this.getAnonymousUser();
        this.eventService.sendMessage({type: 'user', data: this.currentUser});
        if(notification) {
          let modal = this.modalService.open(GenericModalComponent, {
            title: notification.title,
            data: {
                message: notification.body,
                order : 0,
            	addFooterBtn : true,
            	isOk: true,
                centered: true
            }
          }).subscribe();
          setTimeout(() => modal.unsubscribe(), 5000);
        }
        return this.currentUser;
      }, (err) => {
        this.currentUser = this.getAnonymousUser();
        this.eventService.sendMessage({type: 'user', data: this.currentUser});
        return this.currentUser;
      });
  }

  trackCookie(sessionCookieValue) {
    if (sessionCookieValue) {
      const domain = window.location.hostname.split('.').slice(-2).join('.');
      Cookie.set('JSESSIONID', sessionCookieValue, 365, '/', domain);
      // console.log('JSESSIONID:' + sessionCookieValue);
    } else {
      // console.log('No JSESSIONID');
    }
  }

  public checkLoggedIn(tempUser?: any, googleState?: string, googleCode?: string): Observable<User> {
        if (!this.currentUser.isLoggedIn) {
            let authUrl = '';
            if (tempUser && googleState && googleCode) {
            	let userInfo = this.encryptUserData(tempUser);
            	if(!tempUser.sendEmail) {
            		tempUser.sendEmail = false;
            	}
                authUrl += `?currentUserLanguage=${window.localStorage.getItem('lang')}&state=${googleState}&code=${googleCode}&userInfo=${userInfo}&sendEmail=${tempUser.sendEmail}`;
            } else if(tempUser) {
            	let userInfo = this.encryptUserData(tempUser);
            	if(!tempUser.sendEmail) {
            		tempUser.sendEmail = false;
            	}
            	authUrl += `?currentUserLanguage=${window.localStorage.getItem('lang')}&userInfo=${userInfo}&sendEmail=${tempUser.sendEmail}`;
            } else {
            	authUrl += `?currentUserLanguage=${window.localStorage.getItem('lang')}`;
            }
            return this.authenticate(authUrl)
                .map((user) => {
                    if (user.isLoggedIn) {
                        this.cleanupLocalStorage();
                        this.currentUser = user;
                    }
                    this.eventService.sendMessage({type: 'user', data: this.currentUser});
                    return this.currentUser;
                }).catch((err) => {
                	if(err.status == 0) {
                		window.location.href='/#/error-page';
                	}
                	return Observable.throw(err);
                });
        } else {
            return Observable.fromPromise(Promise.resolve(this.currentUser));
        }
        // else {
        //       this.currentUser = currentUser;
        //       this.isLoggedIn = this.currentUser.isLoggedIn;
        //       this.userAdmin = this.currentUser.admin;
        // }
        // }, (err) => {
        //   let authUrl = '';
        //   if (this.state && this.code) {
        //     authUrl += `?state=${this.state}&code=${this.code}`;
        //   }
        //   this.loginService.authenticate(authUrl)
        //     .subscribe((data) => {
        //       if (data && data.email) {
        //           this.currentUser = data;
        //           this.isLoggedIn = this.currentUser.isLoggedIn;
        //           this.userAdmin = this.currentUser.admin;
        //       }
        //     });
        // });
    }

    public authenticate(url) {
    // console.log(`Authenticate ${url}`);
    // const fullUrl = 
    return this.http.get(`${environment.baseURL}${environment.auth}${url}`)
      .map((res: Response) => {
        const headers = res.headers;
        this.trackCookie(headers.get('jsessionid'));
        return this.updateCurrentUser(res.json());
      })
      .catch((err) => {
        if(err.status == 0) {
          	window.location.href='/#/error-page';
          	return Observable.throw(err);
        }
        if(err.status == 402 || err.status == 406) {
        	return Observable.throw(err);
        }
        const headers = err.headers;
        if (headers) {
            this.trackCookie(headers.get('jsessionid'));
        }
        this.currentUser = this.getAnonymousUser();
        this.eventService.sendMessage({type: 'user', data: this.currentUser});
        return Observable.fromPromise(Promise.resolve(this.currentUser));
      });
  }

    private prepareForUI(currentUser: User) {
        currentUser.isLoggedIn = true;
        return currentUser;
    }

    public isLoggedIn(): Observable<User> {
        return this.checkLoggedIn();
    }

    public getCurrentUser() {
        return this.currentUser;
    }

    public setAnonymousUser() {
        this.currentUser = this.getAnonymousUser();
        this.cleanupLocalStorage();
    }

    private cleanupLocalStorage() {
        // cleanup any old state
        this.localStorageService.remove('lastRuid');
        this.localStorageService.remove('openLastViewed');
    }

    private getAnonymousUser(): User {
        return {
            pk: 0,
            firstName: '',
            lastName: '',
            admin: false,
            authorities: new Array<any>(),

            email: '',
            paidTo: '',
            phone: '',
            company: '',
            country: '',
            industry: '',
            jobTitle: '',

            mailchimpId: '',
            mailchimpSyncDate: '',

            active: false,
            deleted: false,
            hasExpirationAlert: false,
            hasLicenseInventory: false,
            paid: false,
            premium: false,
            subscribed: false,
            socialAccount: false,

            advancedSubscriptionId: '',
            advancedSubscriptionStatus: '',
            premiumSubscriptionId: '',
            premiumSubscriptionStatus: '',

            // UI properties
            isLoggedIn: false,
            singlePayment: false,
            paymentInProgress: false
        };
    }

  getAccountInfo() {
    return this.http.get(`${environment.baseURL}${environment.account}`)
      .map((response) => {
        return this.updateCurrentUser(response.json());
      });
  }

    private updateCurrentUser(jsonUser) {
        this.currentUser = jsonUser;
        this.currentUser = this.prepareForUI(this.currentUser);
        this.eventService.sendMessage({type: 'user', data: this.currentUser});
        return this.currentUser;
    }

  userLogin(user) {
    const body = `email=${user.email}&password=${user.password}&remember-me=${user.remember_me}`;
    //console.log(environment.baseURL, environment.login);
    return this.http.post(`${environment.baseURL}${environment.login}`, body, {headers: this.setHeaders()})
      .map((res) => {
        const headers = res.headers;
        this.trackCookie(headers.get('jsessionid'));
        return res;
      });
  }

  createUser(user) {
  	let userInfo = this.encryptUserData(user);
    const body = `name=${encodeURIComponent(user.name)}&lastname=${encodeURIComponent(user.lastname)}&email=${user.email}&company=${encodeURIComponent(user.company)}`
        + `&password=${user.password}${user.phone != null ? '&phone=' + user.phone : '' }`
        + `${user.jobtitle != null ? '&jobtitle=' + encodeURIComponent(user.jobtitle) : '' }`
		    + `${user.country != null ? '&country=' + encodeURIComponent(user.country) : '' }`
		    + `${user.industry != null ? '&industry=' + encodeURIComponent(user.industry) : '' }`
		    + `&captchafield=${user.captchafield}`
        + `&agreeToTerms=true&agreeToEmails=true&currentUserLanguage=${window.localStorage.getItem('lang')}`
        + `&userInfo=${userInfo}`;
    return this.http.post(`${environment.baseURL}${environment.signup}`, body, {headers: this.setHeaders()})
      .map((res) => {
        const headers = res.headers;
        this.trackCookie(headers.get('jsessionid'));
        return res;
      });
  }
  
  agreeTermsOfUserByEmail(user) {
	    const queryParams = `?useremail=${user.email}`;
	    return this.http.get(`${environment.baseURL}${environment.signup}/agreeterms${queryParams}`)
	      .map((res) => {
	        const headers = res.headers;
	        this.trackCookie(headers.get('jsessionid'));
	        return res;
	      });
  }

  resetPassword(data) {
    let queryParams = '';
    if (data.oldPassword) {
      queryParams = `oldPassword=${ data.oldPassword}&newPassword1=${data.newPassword}&newPassword2=${data.confirmPassword}`;
    } else if (data.passwordResetId) {
      queryParams = `newPassword1=${data.newPassword}&newPassword2=${data.confirmPassword}&passwordResetId=${data.passwordResetId}`;
    }
    return this.http.post(`${environment.baseURL}${environment.account}/reset-password`, queryParams, {headers: this.setHeaders()})
      .map((res) => {
        return res;
      });
  }

  resetPasswordMail(email) {
    return this.http.get(`${environment.baseURL}${environment.account}/reset-password?email=${email}&currentUserLanguage=${window.localStorage.getItem('lang')}`)
      .map((res) => {
        return res;
      });
  }

  updateAccount(user) {
    const req = {
        firstName: user.firstName,
        lastName: user.lastName
    };
    return this.http.post(`${environment.baseURL}${environment.account}`, req)
      .map((res) => {
          return this.updateCurrentUser(res.json());
      });
  }
  
  getUserInfo() {
	    return this.jsonp.get(`${environment.userInfoURL}?callback=JSONP_CALLBACK`)
	      .map((res) => {
	        return res;
	      });
  }

  private setHeaders(): Headers {
    const headersConfig = {
        'Content-Type': 'application/x-www-form-urlencoded'
    };
    return new Headers(headersConfig);
  }
  
  private encryptUserData(user: any): string {
  	user.userInfoIp = encodeURI(user.userInfoIp);
  	user.userInfoCity = encodeURI(user.userInfoCity);
  	user.userInfoRegion = encodeURI(user.userInfoRegion);
  	user.userInfoCountry = encodeURI(user.userInfoCountry);
    return encodeURI(btoa(`userInfoIp=${user.userInfoIp}|userInfoCity=${user.userInfoCity}|userInfoRegion=${user.userInfoRegion}|userInfoCountry=${user.userInfoCountry}`));
  }

  ngOnDestroy(): void {
    this.subscription.unsubscribe();
  }

}



// WEBPACK FOOTER //
// C:/Work/Projects/OnlineParser/web2-ui/src/app/services/login.service.ts